import { useRouter } from "next/router";
import React from "react";
import { parseURL } from "ufo";

/**
 * Here we use redirect because after 06 Dec 2025 NextJs got epic fail on root route
 * when it used as SPA, and for every route AWS cdn respond with index.html
 */

export default function Page() {
  const router = useRouter();

  React.useEffect(() => {
    const parsed = parseURL(router.asPath);

    if (!parsed.pathname || parsed.pathname === "/") {
      router.replace("/home").then();
    } else {
      router.replace(router.asPath).then();
    }
  }, []);

  return null;
}
